import * as React from 'react';

export default function ParkingGarage({...rest}) {
  return (
    <svg
      {...rest}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.2622 6.38961L12.0002 3.27734L4.73828 6.38961L5.26219 7.61207L12.0002 4.72384L18.7383 7.61207L19.2622 6.38961ZM16.0002 12.0009C16.0002 10.344 14.6571 9.00085 13.0002 9.00085H9.00024V15.0009V19.0009H10.3302V15.0009H13.0002C14.6571 15.0009 16.0002 13.6577 16.0002 12.0009ZM13.0002 13.6709H10.3302V10.3309H13.0002C13.9226 10.3309 14.6702 11.0785 14.6702 12.0009C14.6702 12.9232 13.9226 13.6709 13.0002 13.6709Z"
        fill="#001E50"
      />
    </svg>
  );
}
